import { MainView } from './main.component';

export const Main = MainView;
